import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button, { BUTTON_POSITION, BUTTON_TYPE } from '../../components/Button';
import Price, { CURRENCY } from '../../components/Price';
import Alert, { ALERT_TYPE } from '../../components/Alert';
import { RepositoryContext } from '../../store/RepositoryProvider';
import API from '../../server/api';
import log from '../../utils/logger';
import { APICode } from '../../models/types';

const TakeSalary = ({ onCancel, onApply, amountMax }) => {
  const {t} = useTranslation(['common']);

  const repository = useContext(RepositoryContext);

  const [salary, setSalary] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);
  const [otherResult, setOtherResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
  }, []);

  useEffect(() => {
    if (salary > 0 && salary > amountMax) {
      setError(t('cashbox:total_salary.error.over_limit'));
    } else {
      setError('');
    }
  }, [salary]);

  const handleTakeSalary = useCallback(async () => {
    if (!error && salary > 0) {
      setIsLoading(true);

      repository.action(API.cashier.withdrawSalary, { amount: salary }).then((salaryResult) => {
        if (salaryResult.amount === salary) {
          setSuccess(t('cashbox:total_salary.success', {amount: Price.Text({value: salaryResult.amount})}));
        } else {
          setOtherResult(t('cashbox:total_salary.take_amount', {amount: Price.Text({value: salaryResult.amount})}));
        }
        setIsLoading(false);
        setSalary(null);
        typeof onApply === 'function' && onApply(salaryResult);
      }).catch((error) => {
        log.error(error);
        setIsLoading(false);
        if (error.error === APICode.TOO_MANY_REQUESTS) {
          setError(t('cashbox:total_salary.error.too_many_requests'));
        } else {
          setError(t('cashbox:total_salary.error.fail'));
        }
      });
    } else {
      setIsLoading(false);
    }

    setError(null);
    setSuccess(null);
    setOtherResult(null);
  }, [error, salary]);

  const handleCancel = useCallback(() => {
    typeof onCancel === 'function' && onCancel();
  }, []);

  return (
    <div className="trip-app">
      <div className="trip-app-body">
        {error && (
          <Alert type={ALERT_TYPE.ERROR} dismissible={true}>{error}</Alert>
        )}
        {success && (
          <Alert type={ALERT_TYPE.SUCCESS} dismissible={true}>{success}</Alert>
        )}
        {otherResult && (
          <Alert type={ALERT_TYPE.WARN} dismissible={true}>{otherResult}</Alert>
        )}
       <div className="field">
         <div className="field-label pt-3">
           <span>{t('cashbox:total_salary.amount')}</span>
           <span className="link-action_dashed"><Price currency={CURRENCY.RUB} value={amountMax} onClick={() => setSalary(amountMax)}/></span>
         </div>
         <Price.Input2 placeholder={0} max={amountMax} min={0} value={salary} onChange={(value) => setSalary(value <= 0 ? null : value)}/>
       </div>
        <div className="mb-4">{t('cashbox:total_salary.note')}</div>
      </div>
      <div>
        <Button.Panel>
          <Button variant={BUTTON_TYPE.PRIMARY} position={BUTTON_POSITION.LEFT} onClick={handleTakeSalary} disabled={salary <= 0 || !!error || isLoading}>{t('common:button.execute')}</Button>
          <Button variant={BUTTON_TYPE.SECONDARY} position={BUTTON_POSITION.RIGHT} onClick={handleCancel}>{t('common:button.cancel')}</Button>
        </Button.Panel>
      </div>
    </div>
  );
}

TakeSalary.propTypes = {
  onSelect: PropTypes.func,
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  amountMax: PropTypes.number.isRequired
};

export default TakeSalary;